<template>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="3" y="6" width="18" height="15" rx="2" stroke="currentColor" stroke-width="2"/>
    <path d="M4 11H20" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
    <path d="M9 16H15" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
    <path d="M8 3L8 7" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
    <path d="M16 3L16 7" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
    </svg>
</template>